/**
 * Copyright (C) Sitevision 2002-2021, all rights reserved
 *
 * @author Sjöstrand
 */
import $ from '@sv/jquery';
import sv from '@sv/core';
import { getModelObjectUri } from '../util/portletUtil';
import { KeyUtil as keyUtil, Ajax as ajax } from '@sv/util';
import loadingImg from '../util/static/img/loading_16_grey.gif';


const inputConfig = {
  triggers: {
    '@': {
      source: getModelObjectUri(
        sv.PageContext.pageId,
        'userIdentitySearch',
        sv.PageContext.pageId
      ),
      searchKey: 'term',
      allowWhiteSpace: true,
      maxWhiteSpace: 2,
      parse: (response) => {
        return response.hits;
      },
    },
  },
  minLength: 2,
  replacer: (item) => {
    return `${item.trigger}{"value":"${item.name}","id":"${item.id}"}`;
  },
};
const KEY = keyUtil.KEY;

export const initComment = ($el) => {
  const $container = $el.closest('[data-fn-commentlike-container]');
  const commentContainerSelector = `#${$el.attr('data-comment-container')}`;
  const $textField = $container.find('[data-fn-comments-input]');

  if ($container.data('sv-fn-initialized')) {
    const $mainContainer = $(commentContainerSelector);
    if ($mainContainer.is(':hidden')) {
      $mainContainer.fadeIn('fast', () => {
        $textField.trigger('focus');
      });
    } else {
      $mainContainer.fadeOut('fast');
    }

    return;
  }
  $container.data('sv-fn-initialized', 'true');

  const maxCharacterCount = $container
    .find('[data-fn-comments-input-size]')
    .attr('data-initial-size');
  const $submit = $container.find('[data-fn-comments-submit]');
  const $form = $container.find('[data-fn-comments-form]');

  const $loader = $('<img>')
    .attr('src', loadingImg)
    .css({ 'vertical-align': 'middle', display: 'none' });

  function countdownCharactersLeft(e) {
    const $target = $(e.currentTarget);
    const text = $target.val();
    const size = maxCharacterCount - text.length;
    const $sizeField = $target.parent().find('[data-fn-comments-input-size]');

    if (size < 0) {
      $sizeField.addClass('sv-character-limit-exceeded');
    } else {
      $sizeField.removeClass('sv-character-limit-exceeded');
    }
    $sizeField.text(size);
    if ($target.val().trim() !== '' && size >= 0 && !this.activeConnection) {
      $submit.removeClass('disabled').prop('disabled', false);
    } else {
      $submit.addClass('disabled').attr('disabled', 'disabled');
    }
  }

  function checkKeyDown(e) {
    const key = keyUtil.getKeyCodeFromEvent(e);
    if (key === KEY.RETURN && e.ctrlKey) {
      $submit.trigger('focus');
      $form.trigger('submit');
      return false;
    }
  }

  function postComment(e) {
    let loaderTimeout;

    // Have to check if default is prevented. Because Firefox will run keyPress event
    // even if default is prevented. Other browsers will not... So to prevent the comment
    // from being posted when selecting a mention we have to run this check...
    if (!(e.isPropagationStopped() || e.isDefaultPrevented())) {
      e.preventDefault(); // Make sure form isn't POSTed
      if (this.activeConnection) {
        return false;
      }

      const commentLength = $textField.val().trim().length;
      const richTextMessage = $textField.triggeredInput('getRichContent');

      if (commentLength > 0 && commentLength <= maxCharacterCount) {
        $submit.addClass('disabled').attr('disabled', 'disabled');
        this.activeConnection = true;

        const url = $form.attr('action');
        let selectorSuffix = 'thank';

        ajax
          .doPost({
            url: url,
            data: {
              comment: richTextMessage,
            },
          })
          .then(() => {
            const $counter = $container.find('[data-fn-comment-count]');
            const newCount = parseInt($counter.text(), 10) + 1;
            $counter.text(newCount);
          })
          .catch(() => {
            selectorSuffix = 'error';
          })
          .always(() => {
            $loader.hide();
            clearTimeout(loaderTimeout);
            const baseSelector = `#${$el.attr('data-comment-container')}`;
            $(baseSelector).hide();
            $(`${baseSelector}_${selectorSuffix}`).show();
            setTimeout(() => {
              $(`${baseSelector}_${selectorSuffix}`).fadeOut('fast');
            }, 5000);
            $textField.val('');
            this.activeConnection = false;
          });

        $loader.appendTo($textField.parent());
        loaderTimeout = setTimeout(() => {
          $loader.show();
        }, 400);

        return false;
      }
    }

    return false;
  }

  $textField.triggeredInput(inputConfig).elastic();
  $textField.on('keydown', checkKeyDown);
  $textField.on('keyup', countdownCharactersLeft);
  $form.on('submit', postComment);

  $(commentContainerSelector).fadeIn('fast', () => {
    $textField.trigger('focus');
  });
};
